(() => {
  if (window.lieneHalloweenFormScrollV3) return;
  window.lieneHalloweenFormScrollV3 = true;
  let cancelActive = () => {};
  // Capture before the theme's generic anchor handler and the old hotspot handler.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !link.closest('x-slideshow[data-halloween-form-slider]') || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
    let id;
    try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (!target || !target.matches('.lfe')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    cancelActive();
    const slider = link.closest('x-slideshow[data-halloween-form-slider]');
    const section = target.closest('.shopify-section') || target;
    const nav = document.querySelector('liene-deal-nav');
    const navSection = nav?.closest('.shopify-section');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const started = performance.now();
    const initialY = window.scrollY;
    let frame, cancelled = false, settled = false, lastGoal;
    const events = ['wheel', 'touchstart', 'pointerdown', 'keydown'];
    const cancel = () => {
      cancelled = true;
      cancelAnimationFrame(frame);
      events.forEach(name => window.removeEventListener(name, cancel, true));
    };
    cancelActive = cancel;
    events.forEach(name => window.addEventListener(name, cancel, { capture: true, passive: true }));
    const destination = () => {
      // Reserve the header's full height even when it is temporarily hidden while scrolling.
      let headerHeight = 0;
      document.querySelectorAll('.lh-header, .shopify-section--header').forEach(header => {
        const style = getComputedStyle(header), rect = header.getBoundingClientRect();
        if (style.display !== 'none' && rect.width && ['fixed', 'sticky'].includes(style.position)) {
          headerHeight = Math.max(headerHeight, rect.height);
        }
      });
      const navHeight = navSection ? navSection.getBoundingClientRect().height : 0;
      const mobile = matchMedia('(max-width: 699px)').matches;
      const configured = slider.getAttribute(mobile ? 'data-form-scroll-gap-mobile' : 'data-form-scroll-gap');
      const gap = configured === null ? 80 : Number(configured);
      const reserve = headerHeight + navHeight + (Number.isFinite(gap) ? gap : 80);
      return Math.max(0, Math.min(section.getBoundingClientRect().top + window.scrollY - reserve, document.documentElement.scrollHeight - window.innerHeight));
    };
    const tick = (now) => {
      if (cancelled || !section.isConnected) return cancel();
      const elapsed = now - started, goal = destination();
      if (!settled) {
        const progress = reduced ? 1 : Math.min(1, elapsed / 650);
        const eased = 1 - Math.pow(1 - progress, 3);
        window.scrollTo({ top: initialY + (goal - initialY) * eased, behavior: 'instant' });
        if (progress === 1) {
          settled = true;
          if (!section.hasAttribute('tabindex')) {
            section.setAttribute('tabindex', '-1');
            section.addEventListener('blur', () => section.removeAttribute('tabindex'), { once: true });
          }
          section.focus({ preventScroll: true });
        }
      } else if (Math.abs(goal - lastGoal) > 1) {
        // Images, embedded forms and headers can change layout after the click.
        window.scrollTo({ top: goal, behavior: 'instant' });
      }
      lastGoal = goal;
      if (elapsed < 4000) frame = requestAnimationFrame(tick);
      else cancel();
    };
    history.replaceState(history.state, '', url.hash);
    frame = requestAnimationFrame(tick);
  }, true);
})();